import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">

        {/* Brand / About */}
        <div className="footer-col brand">
          <div className="footer-logo">Charamy</div>
          <p className="footer-desc">
            Unlock powerful growth for your crypto brand by partnering with our
            verified KOL network and crypto-native team.
          </p>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <div className="col-title">Contact Us</div>
          <a href="mailto:contact@charamy.org" className="footer-link">
            contact@charamy.org
          </a>
        </div>

        {/* Follow Us */}
        <div className="footer-col follow">
          <div className="col-title">Follow Us</div>

          <div className="socials">
            {/* Telegram */}
            <a
              href="https://t.me/xxtomxyz"
              target="_blank"
              rel="noreferrer"
              aria-label="Telegram"
              className="social-icon"
            >
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M9.036 15.803l-.374 5.28c.534 0 .765-.229 1.04-.504l2.497-2.41 5.176 3.79c.948.524 1.622.25 1.88-.878l3.404-15.943c.303-1.414-.512-1.967-1.433-1.62L1.536 9.29C.165 9.822.186 10.61 1.3 10.961l5.21 1.626 12.12-7.644"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>

            {/* X (Twitter) */}
            <a
              href="https://x.com/CharamyORG"
              target="_blank"
              rel="noreferrer"
              aria-label="X"
              className="social-icon"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 3l8.5 10.2L3.8 21h2.2l6.7-6.7L18.8 21H21l-8.9-10.7L20.2 3h-2.2l-6.1 6.1L7 3H3z" />
              </svg>
            </a>

            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/in/charamy-org-bb6aa9388"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              className="social-icon"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M4.98 3.5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zM3 8.98h3.96V21H3V8.98zM9.98 8.98h3.79v1.64h.05c.53-1 1.83-2.06 3.77-2.06 4.03 0 4.78 2.65 4.78 6.1V21h-3.96v-5.33c0-1.27-.02-2.9-1.77-2.9-1.77 0-2.04 1.38-2.04 2.8V21H9.98V8.98z" />
              </svg>
            </a>

            {/* Medium */}
            <a
              href="https://medium.com/@charamyorg"
              target="_blank"
              rel="noreferrer"
              aria-label="Medium"
              className="social-icon"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M2 6.5l4.5 2.6v9.8L2 21V6.5zm5.7 3.2L14 21l6-3.5L13.7 6l-6 3.7zM14.6 3l4.4 2.6-4.4 2.6L10.2 5.6 14.6 3z" />
              </svg>
            </a>

       
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Charamy. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
